import { Action } from '../types';

export const openAwsCaptchaModal = (): Action => ({
  type: 'OPEN_AWS_CAPTCHA_MODAL',
});

export const closeAwsCaptchaModal = (): Action => ({
  type: 'CLOSE_AWS_CAPTCHA_MODAL',
});
